module.exports = __webpack_public_path__ + "static/media/safari_logo.93d337fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/browser/safari_logo.svg
// module id = 1604
// module chunks = 0